export default __webpack_public_path__ + "static/media/video-and-creative-production.7cc45554.svg";